import { GoogleServiceLib } from "../../../libs/client/libs/google";
import { config } from "../../config";

export const GoogleService = GoogleServiceLib(config.services.google.api_key);

GoogleService.fonts.list();
